import getMatchedContenteditableType from './get-matched-contenteditable-type';
import isContenteditableRich from './is-contenteditable-rich';
import isContenteditableDisabled from './is-contenteditable-disabled';

export default {
  getMatchedContenteditableType,
  isContenteditableRich,
  isContenteditableDisabled,
};
